module.exports = __webpack_public_path__ + "static/media/44493038_2199888756752970_8785936257776615424_o.70c84d4a.jpg";